import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { LanguageService } from "../../services/language.service";

@Component({
  selector: "app-file-preview",
  templateUrl: "./file-preview.component.html",
  styleUrls: ["./file-preview.component.css"]
})
export class FilePreviewComponent implements OnInit {
  previewSupported: boolean = true;
  isImage: boolean = false;
  faInfoCircle = faInfoCircle;

  @ViewChild('filepreview') fileElement: ElementRef;
  @ViewChild('imagepreview') imageElement: ElementRef;

  constructor(public language: LanguageService) { }

  ngOnInit() {    
  }

  show(file: Blob) {
    if (this.isTypeSupported(file.type)) {
      this.previewSupported = true;
      // show file preview
      if (this.isImage) {
        let el = this.imageElement;
        const reader = new FileReader();
        reader.addEventListener("load", function () {
          // convert to base64 string
          el.nativeElement.src = reader.result as string;          
        }, false);
        reader.readAsDataURL(file);
      } else {
        let el = this.fileElement;        
        const reader = new FileReader();
        reader.addEventListener("load", function () {
          // convert to base64 string
          el.nativeElement.src = reader.result as string;
        }, false);
        reader.readAsDataURL(file);
      }
    } else {
      // Preview not supported
      this.previewSupported = false;
    }
  }

  isTypeSupported(mimeType: string) {    
    // List of MIME types: https://www.iana.org/assignments/media-types/media-types.xhtml
    // What we currently support (does not require a 3-party plugin)
    if (mimeType === 'text/plain'
      || mimeType === 'text/css'
      || mimeType === 'text/html'
      || mimeType === 'text/javascript'
      || mimeType === 'image/apng'
      || mimeType === 'image/bmp'
      || mimeType === 'image/gif'
      || mimeType === 'image/x-icon'
      || mimeType === 'image/jpeg'
      || mimeType === 'image/png'
      || mimeType === 'image/svg+xml'
      || mimeType === 'image/tiff'
      || mimeType === 'image/webp'
      || mimeType === 'application/pdf') {
      if (mimeType.startsWith('image')) {
        this.isImage = true;
      } else {
        this.isImage = false;
      }            
      return true;
    }

    this.isImage = false;
    return false;
  }

}
